import homepage from './homepage.json';

export default { ...homepage };
